import { combineReducers } from 'redux';

const extractFilter = (state = {}, action: any) => {
  switch (action.type) {
    case 'ADD_FILTER_EXTRACT':
      return { ...state, ...action.filter };
    case 'RESET_FILTER_EXTRACT':
      return {};
    case 'GET_FILTER_EXTRACT':
      return { ...state };
    default:
      return { ...state };
  }
};

export const extractFilterReducer = combineReducers({
  extractFilter,
});
